import { useEffect, useState } from "react";
import { Moon, Sun, Monitor, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export function applyTheme(mode) {
  const isDark = mode === "dark" || (mode === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", isDark);
}

export function ThemeToggle({ className = "" }) {
  const [mode, setMode] = useState(() => localStorage.getItem("theme") || "system");

  useEffect(() => {
    applyTheme(mode);
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => { if ((localStorage.getItem("theme") || "system") === "system") applyTheme("system"); };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [mode]);

  const choose = (m) => { setMode(m); localStorage.setItem("theme", m); applyTheme(m); };
  const Icon = mode === "dark" ? Moon : mode === "light" ? Sun : Monitor;

  const item = (m, label, IconC) => (
    <DropdownMenuItem data-testid={`theme-${m}`} onClick={() => choose(m)} className="justify-between">
      <span className="flex items-center gap-2"><IconC className="h-4 w-4" /> {label}</span>
      {mode === m && <Check className="h-4 w-4 text-primary" />}
    </DropdownMenuItem>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="theme-toggle"
          aria-label="Theme"
          title="Theme"
          className={`flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600 transition-colors hover:bg-slate-50 ${className}`}
        >
          <Icon className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {item("light", "Light", Sun)}
        {item("dark", "Dark", Moon)}
        {item("system", "System", Monitor)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
